/**
 * Returns the value for the given key
 * @param key Key of the object
 * @param obj Object
 * @returns Value of the key
 */
export const getValue = <T>(key: string, obj: T) => {
  if (!obj || !key) return;
  type ObjectKey = keyof typeof obj;
  return obj[key as ObjectKey] ?? undefined;
};

/**
 * Returns the value for the given key
 * @param key Key of the object
 * @param obj Object
 * @returns Value of the key
 */
export const getTypedValue = <T>(key: string, obj: unknown) => {
  try {
    if (!obj || !key) return;
    type ObjectKey = keyof typeof obj;
    return (obj[key as ObjectKey] as T) ?? undefined;
  } catch (error) {
    console.error(error);
    return;
  }
};
